import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TabDirective, TabsetComponent } from 'ngx-bootstrap/tabs/public_api';
import { ApiService } from 'src/app/_services/api.service';

@Component({
  selector: 'app-declineinvalue',
  templateUrl: './declineinvalue.component.html',
  styleUrls: ['./declineinvalue.component.scss']
})
export class DeclineinvalueComponent implements OnInit {

  @ViewChild('staticTabs', { static: false }) staticTabs: TabsetComponent;
  pageId: string;
  pageName: string = "Decline In Value/ Property Tax Relief";
  id: number;
  open: boolean=true;
  tab='General Info'
  enable: boolean = true;
  randomBool: boolean = true;
  FaqData: any;
  FormData: any;
  date = new Date().getFullYear();
  name_browser = '';
  isChrome: boolean = false;

  selectTab(tabId: number) {
    this.staticTabs.tabs[tabId].active = true;
  }

  constructor(private actRoute: ActivatedRoute,  private apiService: ApiService,) {
    this.id = this.actRoute.snapshot.params.id;
  }

  onSelect(data: TabDirective): void {
    this.tab = data.heading;
    // console.log('tab ' + this.tab);
    if(!this.pageId) {

      this.apiService.getPage(this.pageName).subscribe(data => {
        this.pageId = data.id.toString();
        if(this.tab.toLowerCase() === 'faq') {
          this.getFaq();
        }
        else if(this.tab.toLowerCase() == 'forms') {
          this.getForm();
        }

      })
    }
    else {
      if(this.tab.toLowerCase() === 'faq') {
        this.getFaq();
      }
      else if(this.tab.toLowerCase() == 'forms') {
        this.getForm();
      }

    }

  }
  getFaq() {
    // console.log(this.pageName)
    this.apiService.getFaqByPage(this.pageId).subscribe(data => {
      this.FaqData = data;
      // console.log(data);
    })

  }

  getForm() {
    this.apiService.getFormByPage(this.pageId).subscribe(data => {
      this.FormData = data;

    })
  }
  //Find browser name
  findname_browser() {
    const agent = window.navigator.userAgent.toLowerCase()
    // console.log(agent);
    switch (true) {
      case agent.indexOf('edg') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }

  isChromeBrowser(){
    const agent = window.navigator.userAgent.toLowerCase()
    switch (true) {
      case agent.indexOf('edg') > -1:
        return false;
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return true;

      default:
        return false;
    }
  }

  ngAfterViewInit() {
    console.log(this.id);
  }
  ngOnInit() {
    //this.name_browser = this.findname_browser();
    this.isChrome = this.isChromeBrowser();
  }



}
